import styled from 'styled-components';

export const EmptyLargeContainer = styled.div`
  display: flex;
  flex-direction: column;

  text-align: center;
  align-items: center;
  justify-content: center;

  gap: 24px;
  margin: 0;
  padding: 24px;

  [role='img'] {
    font-size: 120px;
    color: ${({ theme }) => theme.palette.common.PRIMARY};
  }

  h2 {
    margin: 0;
    padding: 0;
    font-size: 28px;
    font-weight: 700;
    font-family: ${({ theme }) => theme.fonts.secondary};
  }

  p {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: 500;
  }
`;

export const EmptySmallContainer = styled.div`
  display: flex;

  text-align: center;
  align-items: center;
  justify-content: center;

  gap: 8px;
  margin: 0;
  padding: 16px;
  border-radius: 8px;

  background: ${({ theme }) => theme.palette.common.XLIGHT_GREEN};

  [role='img'] {
    font-size: 24px;
    color: ${({ theme }) => theme.palette.common.PRIMARY};
  }

  p {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: 500;
  }
`;
